import {App} from "@vue/runtime-core"
import primeVue from "primevue/config"
import ToastService from "primevue/toastservice"
import ConfirmationService from "primevue/confirmationservice"
import Toast from "primevue/toast"
import Message from "primevue/message"
import ConfirmDialog from "primevue/confirmdialog"
import Dialog from "primevue/dialog"
import Tooltip from "primevue/tooltip"
import OverlayPanel from "primevue/overlaypanel"
import Card from "primevue/card"
import Tabview from "primevue/tabview"
import Tabpanel from "primevue/tabpanel"
import Button from "primevue/button"
import ToggleButton from "primevue/togglebutton"
import InputText from "primevue/inputtext"
import InputNumber from "primevue/inputnumber"
import Password from "primevue/password"
import Textarea from "primevue/textarea"
import Calendar from "primevue/calendar"
import Checkbox from "primevue/checkbox"
import Dropdown from "primevue/dropdown"
import FileUpload from "primevue/fileupload"
import Toolbar from "primevue/toolbar"
import Menu from "primevue/menu"
import Paginator from "primevue/paginator"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Menubar from "primevue/menubar"
import AutoComplete from "primevue/autocomplete"
import PanelMenu from "primevue/panelmenu"
import RadioButton from "primevue/radiobutton"
import primevueLocaleJa from "@/primevue/locales/primevue-locale-ja"

export const initializePrimeVue = (app: App) => {

    app.use(primeVue, {
        locale: primevueLocaleJa,
    })

    app.use(ToastService)
    app.use(ConfirmationService)
    app.directive("tooltip", Tooltip)

    app.component("Toast", Toast)
    app.component("Message", Message)
    app.component("ConfirmDialog", ConfirmDialog)
    app.component("Dialog", Dialog)
    app.component("OverlayPanel", OverlayPanel)
    app.component("Card", Card)
    app.component("Tabview", Tabview)
    app.component("Tabpanel", Tabpanel)
    app.component("Button", Button)
    app.component("ToggleButton", ToggleButton)
    app.component("InputText", InputText)
    app.component("InputNumber", InputNumber)
    app.component("Password", Password)
    app.component("Textarea", Textarea)
    app.component("Calendar", Calendar)
    app.component("Checkbox", Checkbox)
    app.component("Dropdown", Dropdown)
    app.component("FileUpload", FileUpload)
    app.component("Toolbar", Toolbar)
    app.component("Menu", Menu)
    app.component("Paginator", Paginator)
    app.component("DataTable", DataTable)
    app.component("Column", Column)
    app.component("Menubar", Menubar)
    app.component("AutoComplete", AutoComplete)
    app.component("PanelMenu", PanelMenu)
    app.component("RadioButton", RadioButton)
}
